import type React from 'react';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ADigitProps } from '@marriott/mi-web-ui-kit';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ABodyProps } from '@marriott/mi-web-ui-kit';

export enum MTimerAlignment {
  Left = 'Left',
  Centered = 'Centered',
}

export interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

export type MTimerProps = React.HTMLAttributes<HTMLDivElement> & {
  // Existing static props (for backward compatibility)
  alignment?: MTimerAlignment;
  aDigit?: ADigitProps;
  aBody?: ABodyProps;

  // New countdown mode props - simple string labels
  targetDate?: string; // ISO date string - if provided, enables countdown mode
  daysLabel?: string;
  hoursLabel?: string;
  minutesLabel?: string;
  secondsLabel?: string;
  updateInterval?: number;
  screenReaderInterval?: number;
  onComplete?: () => void;
  isAuthorMode?: boolean;
  isLoading?: boolean;
  bodyText?: string; // Optional descriptive text to announce with timer (HTML tags will be stripped)
};
